import Cookie from "universal-cookie";

const cookie = new Cookie();

class CookieService {
    get(key) {
        return cookie.get(key)
    }

    set(key, value) {
        let date = new Date();
        date.setTime(date.getTime() + (60 * 24 * 3) * 60 * 1000);
        cookie.set(key, value, { path: "/", expires: date, secure: false, sameSite: true });
    }

    remove(key) {
        cookie.remove(key, { path: "/"});
    }
}

export default new CookieService();